import classNames from 'clsx';
import React from 'react';

import BackgroundImage from '../../assets/path_identity.svg';

import styles from './Card.scss';

export interface CardProps {
  image: string;
  className: string;
  passValuePrice: string;
}
// TODO: fix pass value text when is ready https://jira.pyrsoftware.ca/jira/browse/LMS-18958
const passValueText = { defaultMessage: 'Pass Value' };

const PassCard: React.FC<CardProps> = ({ image, className, passValuePrice }) => (
  <div className={classNames(styles.card, styles.passCard)}>
    <BackgroundImage
      className={classNames(styles.passBackground, styles[className as keyof typeof styles])}
    />
    <div className={styles.passContainer}>
      <img src={image} width={168} height={105} alt={`${className} pass ticket graphic`} />
    </div>
    <div className={styles.passValuePriceContainer}>
      <div className={styles.passValuePriceTile}>{passValueText.defaultMessage}</div>
      <div className={classNames(styles.passValuePrice, styles[className as keyof typeof styles])}>
        {passValuePrice}
      </div>
    </div>
  </div>
);

export default PassCard;
